import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Fade } from "react-reveal";
import { Alert, Spinner } from "reactstrap";
import Loader from "Component/Common/Loader";
import { withRouter, useHistory, useParams } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";

import { useDispatch, useSelector } from "react-redux";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ar from "react-phone-input-2/lang/ar.json";
// import es from "react-phone-input-2/lang/en.json";

import { constants } from "buffer";
import {
  registerUser,
  getKyc,
  socialLoginRequest,
  getAccessToken,
  sendOtp,
} from "store/actions";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";

const SignUp = (props) => {
  // console.log(es);
  const location = useLocation();
  const navigate = useNavigate();
  const toastr = useToastr();
  const lang = localStorage.getItem("lang");
  const urlParams = new URLSearchParams(location.search);
  const { t } = useTranslation();
  const ref = urlParams.get("ref");
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const { loading } = useSelector(({ Register }) => ({
    loading: Register.loading,
  }));
  const [passwordTypeConfirm, setConfirmPasswordType] = useState("password");

  const [fields, setFields] = useState({
    fname: "",
    lname: "",
    email: "",
    countryCode: "",
    mobileNumber: "",
    role: "USER",
    password: "",
    confirm_password: "",
    kyc: {},
    referralCode: "",
  });

  useEffect(() => {
    if (ref) {
      setFields({
        ...fields,
        referralCode: ref,
      });
    }
  }, []);

  /**
   * Used for control the input and set to the states
   */
  const handleChange = (name) => (e) => {
    const inputValue = e.target.value.trim();

    // Check if name is 'fname' or 'lname', and apply regex validation
    if (name === "fname" || name === "lname") {
      // Regular expression to allow only alphabets
      const regex = /^[A-Za-z]+$/;
      // Check if the trimmed value matches the regex
      if (!regex.test(inputValue)) {
        // If regex validation fails, return without updating state
        return;
      }
    }
    setFields((prev) => ({ ...prev, [name]: inputValue }));
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const toggleConfirmPassword = () => {
    if (passwordTypeConfirm === "password") {
      setConfirmPasswordType("text");
      return;
    }
    setConfirmPasswordType("password");
  };

  /**
   * Used for user registration
   */
  const handleSubmit = () => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}[\]:;<>,.?~\\-])(?=.{8,})/;
    if (
      fields.fname.trim() == "" ||
      fields.lname.trim() == "" ||
      fields.email.trim() == "" ||
      fields.password.trim() == "" ||
      fields.mobileNumber.trim() == "" ||
      fields.confirm_password.trim() == ""
    ) {
      return toastr.error(t("all_fields_required"));
    }

    const isValidPassword = passwordRegex.test(fields.password);
    if (!isValidPassword) {
      return toastr.error(t("password_error"));
    }

    if (fields.password !== fields.confirm_password) {
      return toastr.error(t("password_not_match"));
    }

    /**
     * Used for getting response from signup api
     */
    const callback = (response) => {
      if (response.status == "success") {
        const otpCallback = (otpResponse) => {
          if (otpResponse.status === "success") {
            navigate("/email-verification", {
              state: {
                email: fields?.email,
                role: fields?.role,
                path: "signup",
              },
            });
            toastr.success(t("code-sent") + otpResponse?.data?.email);
          } else {
            toastr.error(otpResponse.message);
          }
        };

        dispatch(
          sendOtp({ role: fields?.role, email: fields?.email }, otpCallback)
        );
      } else {
        toastr.error(response?.message);
      }
    };

    let newObj = {
      fname: fields?.fname?.trim(),
      lname: fields?.lname?.trim(),
      email: fields?.email?.trim(),
      countryCode: fields?.countryCode?.trim(),
      mobileNumber: fields?.mobileNumber?.trim(),
      role: "USER",
      password: fields?.password?.trim(),
      kyc: fields?.kyc,
    };

    if (fields?.referralCode !== "") {
      newObj.ref = fields?.referralCode;
    }
    dispatch(registerUser({ ...newObj, kyc: newObj }, callback));
  };

  const handleBack = () => {
    navigate("/");
  };

  /**
   * Used for user authentication using google OAuth
   */
  const responseGoogle = (response) => {
    const tokenInfoCallBack = (response) => {
      if (response.status == "200") {
        let res = response?.data;

        const callback = (response) => {
          if (response.status == "success") {
            toastr.success(t("login_successfully"));
          } else {
            toastr.error(response.message);
          }
        };
        const info = {
          email: res?.email,
          fname: res?.given_name,
          kyc: {
            fname: res?.given_name,
            lname: res?.family_name,
            email: res?.email,
          },
          lname: res?.family_name,
          role: "USER",
          type: "google",
          google_id: res?.sub,
        };
        dispatch(socialLoginRequest(info, callback));
      } else {
        toastr.error(t("somthing_wrong"));
      }
    };

    dispatch(getAccessToken(response?.access_token, tokenInfoCallBack));
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => responseGoogle(tokenResponse),
  });

  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  /**
   * Used for control the phone and countryCode input
   */
  const handlePhoneChange = (value, country, e, formattedValue) => {
    let afterStr = formattedValue.split(" ").slice(1).join(" ");
    // let afterLife = formattedValue.split(' ').slice(1).join('')

    let code = country?.dialCode;
    setFields({
      ...fields,
      countryCode: code,
      mobileNumber: afterStr,
    });
  };

  /**
   * Used for render the UI of signup page
   */
  return (
    <section className="common_sign_main sign_in p-3 ">
      {loading && <Loader />}

      <Container fluid>
        <div className="common_sign_inner">
          <Row>
            <Col lg={5} md={6} sm={12} className="order-2 order-lg-1">
              <Fade>
                <div className="left_form_part">
                  <div className="arrow_with_head">
                    <svg
                      role="button"
                      onClick={handleBack}
                      width="30"
                      height="30"
                      class="w-6 h-6 text-gray-800 dark:text-white mb-5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 10"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5H1m0 0 4 4M1 5l4-4"
                      />
                    </svg>
                    <h3 className="sign_head mobile_auth_head">
                      {t("cretae_account")}
                    </h3>
                  </div>

                  <Form className="form_sign_inout">
                    <h3 className="sign_head desktop_auth_head">
                      {t("cretae_account")}
                    </h3>

                    <Row>
                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            {t("first_name")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type="text"
                            name="fname"
                            id="fname"
                            placeholder={t("john")}
                            onChange={handleChange("fname")}
                            title={t("fill_this_field")}
                            value={fields.fname}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            {t("last_name")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type="text"
                            name="lname"
                            id="lname"
                            placeholder={t("wick")}
                            onChange={handleChange("lname")}
                            title={t("fill_this_field")}
                            value={fields.lname}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            {t("email_id")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            id="exampleEmail"
                            placeholder={t("signup_email")}
                            onChange={handleChange("email")}
                            title={t("fill_this_field")}
                            value={fields.email}
                          />
                        </FormGroup>
                      </Col>

                      <Label>
                        {t("mobile_number")}{" "}
                        <span className="col_red">
                          <sup>*</sup>
                        </span>
                      </Label>
                      <div className="phonenumber_signup position-relative">
                        <Col lg={12} sm={12}>
                          <FormGroup>
                            <PhoneInput
                              value={fields.countryCode}
                              onChange={handlePhoneChange}
                              localization={lang == "ar" && ar}
                              title={t("fill_this_field")}
                            />
                          </FormGroup>
                        </Col>

                        {/* <FormGroup >
                          <Input
                            type="tel"
                            name="number"
                            id="mobile_number"
                            placeholder=""
                            value={fields?.mobileNumber}
                            onChange={handleChange("mobileNumber")}
                            className="ms-3"
                          />
                        </FormGroup> */}
                      </div>

                      <Col lg={12} sm={12}>
                        <FormGroup className="position-relative">
                          <Label for="examplePassword">
                            {t("password")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type={passwordType}
                            name="password"
                            id="examplePassword"
                            placeholder={t("password")}
                            onChange={handleChange("password")}
                            onKeyDown={handleKeyDown}
                            title={t("fill_this_field")}
                            value={fields.password}
                          />

                          {passwordType === "password" ? (
                            <Button
                              className="eye_btn"
                              onClick={togglePassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="eye_btn"
                              onClick={togglePassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"
                                />
                              </svg>
                            </Button>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg={12} sm={12}>
                        <FormGroup className="position-relative">
                          <Label for="examplePassword">
                            {t("confirm_password")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type={passwordTypeConfirm}
                            name="confirm_password"
                            id="confirm_password"
                            onChange={handleChange("confirm_password")}
                            onKeyDown={handleKeyDown}
                            placeholder="........."
                            title={t("fill_this_field")}
                            value={fields.confirm_password}
                          />
                          {passwordTypeConfirm === "password" ? (
                            <Button
                              className="eye_btn"
                              onClick={toggleConfirmPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="eye_btn"
                              onClick={toggleConfirmPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"
                                />
                              </svg>
                            </Button>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            {t("have_referral")}{" "}
                          </Label>
                          <Input
                            type="text"
                            name="referralCode"
                            id="referralCode"
                            value={fields?.referralCode}
                            onChange={handleChange("referralCode")}
                            title={t("fill_this_field")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button
                      className="btn_sign_in w-100 mt-4 btn_theme"
                      // onClick={() => navigate("/KYC")}
                      onClick={handleSubmit}
                    >
                      {" "}
                      {t("continue")}
                    </Button>

                    {/* <div className="or_col position-relative text-center my-3">
                      <p> {t('or')}</p>
                    </div>

                    <Button className="btn_sign_in w-100 mt-2 mb-4 d-flex align-items-center justify-content-center" onClick={login}>
                      <span className="me-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 256 262"><path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" /><path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" /><path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" /><path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" /></svg>
                      </span>
                      {t('google_signin')}
                      </Button> */}

                    {/* <GoogleOAuthProvider
                      clientId={`554948056563-h60g8tj6215u67fcglpfnc6r3nhieguq.apps.googleusercontent.com`}
                    >
                      <GoogleLogin
                        render={(renderProps) => (
                          <button
                            type="button"
                            className=""
                            onClick={renderProps.onClick}
                            disabled={renderProps.disabled}
                          >
                            Sign in with google
                          </button>
                        )}
                        onSuccess={responseGoogle}
                        onFailure={responseGoogle}
                      // cookiePolicy="single_host_origin"
                      />
                    </GoogleOAuthProvider> */}

                    <div className="dont_have_accoutn text-center pt-4">
                      <p>
                        {t("already_account")}{" "}
                        <Link to="/signin">{t("login_here")}.</Link>
                      </p>
                    </div>
                  </Form>
                </div>
              </Fade>
            </Col>

            <Col lg={7} md={6} sm={12} className="order-1 order-lg-2">
              <Fade>
                <div className="right_gradient_part position-relative">
                  <Link to="/" className="logo">
                    <img
                      src="images/logo.svg"
                      alt="logo"
                      className="img-fluid"
                    />
                  </Link>

                  <div className="signingimg_bottom">
                    <img
                      src="/images/signupimg.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>

                  <div className="right_gradient_text">
                    <h4>{t("track_crypto")}</h4>
                    <p>{t("login_ispublish")}</p>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default SignUp;
